import {getRequest, postRequest} from "../fetchWrapper";

/**
 * Récupération de la liste des sections de devis.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEstimateList = (token, agencyId) => {
    const url = `/api-v1/estimate/${agencyId}/list`;
    return getRequest(url, token)
};

/**
 * Récupération du nombre de devis par catégorie.
 *
 * @param int agencyId Identifiant de l'agence.
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEstimateCategoryListCount = (token, agencyId) => {
    const url = `/api-v1/estimate/${agencyId}/category/total`;
    return getRequest(url, token)
};

/**
 * Lecture de la liste des catégories de devis activées.
 *
 * @param token Jeton d'authentification.
 * @return Response | null Réponse de la requête à l'API.
 */
export const getEstimateCategoryEnabledList = (token) => {
    const url = `/api-v1/estimate/category/enabled/list`;
    return getRequest(url, token)
};

/**
 * Récupération des informations d'un devis.
 *
 * @param int id Identifiant du devis.
 * @param string $token Jeton d'authentification.
 *
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEstimateContent = (token, id, agencyId) => {
    const url = `/api-v1/estimate/${agencyId}/header/${id}/content/list`;
    return getRequest(url, token)
}

/**
 * Récupération de toutes les lignes de devis possibles.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEstimateFullList = (token) => {
    const url = `/api-v1/estimate/list`;
    return getRequest(url, token)
};

/**
 * Mise à jour des données d'un devis.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateEstimateData = (token, body) => {
    const url = `/api-v1/estimate/update`;
    return postRequest(url, body, token)
};

/**
 * Suppression d'un devis.
 *
 * @param string $token Jeton d'authentification.
 * @param object body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const deleteEstimateFromDb = (token, body) => {
    const url = `/api-v1/estimate/delete`;
    return postRequest(url, body, token)
}
